import { client, unwrap } from "@/lib/api-base";
import { bust, cachedGet } from "@/lib/lookup-cache";

/* Clients */
export const arListClients = (params = {}) =>
  cachedGet("/ar/clients", params, () =>
    unwrap(client.get("/ar/clients", { params })),
  );
export const arCreateClient = (payload) => {
  bust("/ar/clients");
  return unwrap(client.post("/ar/clients", payload));
};
export const arUpdateClient = (id, payload) => {
  bust("/ar/clients");
  return unwrap(client.patch(`/ar/clients/${id}`, payload));
};
export const arDeleteClient = (id) => {
  bust("/ar/clients");
  return unwrap(client.delete(`/ar/clients/${id}`));
};

/* AR categories */
export const arListCategories = (params = {}) =>
  cachedGet("/ar/categories", params, () =>
    unwrap(client.get("/ar/categories", { params })),
  );
export const arCreateCategory = (payload) => {
  bust("/ar/categories");
  return unwrap(client.post("/ar/categories", payload));
};
export const arUpdateCategory = (id, payload) => {
  bust("/ar/categories");
  return unwrap(client.patch(`/ar/categories/${id}`, payload));
};
export const arDeleteCategory = (id) => {
  bust("/ar/categories");
  return unwrap(client.delete(`/ar/categories/${id}`));
};

/* Receivables (master) */
export const arListReceivables = (params = {}) =>
  cachedGet("/ar/receivables", params, () =>
    unwrap(client.get("/ar/receivables", { params })),
  );
export const arGetReceivable = (id) =>
  unwrap(client.get(`/ar/receivables/${id}`));
export const arCreateReceivable = (payload) => {
  bust("/ar/receivables");
  return unwrap(client.post("/ar/receivables", payload));
};
export const arUpdateReceivable = (id, payload) => {
  bust("/ar/receivables");
  return unwrap(client.patch(`/ar/receivables/${id}`, payload));
};
export const arStopReceivable = (id) => {
  bust("/ar/receivables");
  return unwrap(client.post(`/ar/receivables/${id}/stop`));
};
export const arReactivateReceivable = (id) => {
  bust("/ar/receivables");
  return unwrap(client.post(`/ar/receivables/${id}/reactivate`));
};
export const arDeleteReceivable = (id) => {
  bust("/ar/receivables");
  return unwrap(client.delete(`/ar/receivables/${id}`));
};
export const arArchiveReceivable = (id) => {
  bust("/ar/receivables");
  return unwrap(client.post(`/ar/receivables/${id}/archive`));
};
export const arUnarchiveReceivable = (id) => {
  bust("/ar/receivables");
  return unwrap(client.post(`/ar/receivables/${id}/unarchive`));
};

/* Occurrences */
export const arListOccurrences = (params = {}) =>
  unwrap(client.get("/ar/occurrences", { params }));
export const arGetOccurrence = (id) =>
  unwrap(client.get(`/ar/occurrences/${id}`));
export const arPatchOccurrence = (id, payload) =>
  unwrap(client.patch(`/ar/occurrences/${id}`, payload));
export const arCancelOccurrence = (id) =>
  unwrap(client.post(`/ar/occurrences/${id}/cancel`));
export const arMarkOccurrenceNotDue = (id) =>
  unwrap(client.post(`/ar/occurrences/${id}/mark_not_due`));
export const arRestoreOccurrence = (id) =>
  unwrap(client.post(`/ar/occurrences/${id}/restore`));

/* Collections */
export const arListCollections = (params = {}) =>
  unwrap(client.get("/ar/collections", { params }));
// v1.60.3: aggiunta variante idempotente. `arCreateCollection` continua
// a esistere per retro-compatibilità (POST senza header — permette due
// parziali distinti se il chiamante non passa una chiave).
export const arCreateCollection = (payload, opts = {}) => {
  if (opts.idempotencyKey) {
    const { postFinancialMovement } = require("@/lib/idempotency");
    return postFinancialMovement("/ar/collections", payload, opts).then((r) => r.data);
  }
  return unwrap(client.post("/ar/collections", payload));
};
export const arDeleteCollection = (id) =>
  unwrap(client.delete(`/ar/collections/${id}`));

/* Daily receipts (Prima Nota Incassi) */
export const arListDailyReceipts = (params = {}) =>
  unwrap(client.get("/ar/daily-receipts", { params }));
// v1.60.3: variante idempotente per il Dialog "Nuovo incasso".
export const arCreateDailyReceipt = (payload, opts = {}) => {
  if (opts.idempotencyKey) {
    const { postFinancialMovement } = require("@/lib/idempotency");
    return postFinancialMovement("/ar/daily-receipts", payload, opts).then((r) => r.data);
  }
  return unwrap(client.post("/ar/daily-receipts", payload));
};
export const arUpdateDailyReceipt = (id, payload) =>
  unwrap(client.patch(`/ar/daily-receipts/${id}`, payload));
export const arDeleteDailyReceipt = (id) =>
  unwrap(client.delete(`/ar/daily-receipts/${id}`));
export const arDailyReceiptsSummary = (params = {}) =>
  unwrap(client.get("/ar/daily-receipts-summary", { params }));
